/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for authentication.
 */
'use strict';

angular
  .module('services.auth', ['ngCookies', 'http.account'])
  /**
   * Factory used to access and manipulate auth related data.
   */
  .factory('authFactory', function (httpAccount, SF_LOCATIONS) {
    var authFactory = {},
      userInfo;

    userInfo = httpAccount.getCurrentUser();

    if (!userInfo) {
      throw new Error('Unable to receive user data');
    }

    /**
     * Returns a promise for the user info.
     *
     * @returns {promise} Returns a promise for the user info.
     */
    authFactory.getSignedRequest = function () {
      return userInfo;
    };

    /**
     * Utility method to determine if the app is currently being viewed inside a chatter post.
     * @returns {boolean} True if in chatter.
     */
    authFactory.displayedInChatter = function () {
      return authFactory.getSignedRequest().then(function (signedRequest) {
        return signedRequest.context.environment.displayLocation === SF_LOCATIONS.CHATTER;
      });
    };

    /**
     * Update the adminOnly value for the org.
     *
     * @param {Boolean} adminOnly - The new value for adminOnly.
     * @returns {Promise} A Promise that resolves to true when the value is updated, false otherwise.
     */
    authFactory.updateAdminOnly = function (adminOnly) {
      return httpAccount.updateAdminOnly(adminOnly);
    };

    authFactory.updateITCFeature = function (itComplete) {
      return httpAccount.updateITCFeature(itComplete);
    };

    authFactory.getRedirectUrlToBindOrganization = function () {
      return httpAccount.getRedirectUrlToBindOrganization();
    };

    authFactory.getRedirectUrlToUnBindOrganization = function () {
      return httpAccount.getRedirectUrlToUnBindOrganization();
    };

    return authFactory;
  });
